// Dependencies
import styled from "styled-components";

// Utils
import { theme } from "config/theme";

export const ChartContainer = styled.svg`
    width: 144px;
    height: 144px;
    border-radius: 200px;

    &:not(:root) {
        overflow: visible;
    }
`;

export const ChartSlice = styled.g`
    cursor: pointer;
`;

export const ChartEmptyZone = styled.circle`
    fill: #fff;
    cursor: default;
`;

export const TooltipContainer = styled.div`
    width: fit-content;
    height: 40px;

    padding: 12px;
    border-radius: 200px;
    background-color: ${theme.colors.base[400]};
    border: 1px solid ${theme.colors.base[400]};

    display: flex;
    justify-content: center;
    align-items: center;

    pointer-events: none;
    position: fixed;
    transform: translate(-50%, -100%);

    &::before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px;

        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border-color: ${theme.colors.base[400]} transparent transparent transparent;
    }
`;

export const TooltipLabel = styled.p`
    color: #ffffff;
    white-space: nowrap;
`;
